import { useMutation } from '@tanstack/react-query'
import { paths } from '../../../../api/pathsApi'
import { ValidateResponse } from '../types'
import { aquaApi } from '../../../../api/aquaApi'
import { useRef } from 'react'

const getData = async (caseId: number) => {
  const { data } = await aquaApi.get<ValidateResponse>(paths().HEALT.VALIDATE(caseId))
  return data
}

interface Args {
  onError: (caseNumbers: string[], message: string) => void
  onSuccess: (caseNumbers: string[]) => void
}

export const useValidation = ({ onError, onSuccess }: Args) => {
  const casesNumbers = useRef<string[]>([])

  const mutation = useMutation({
    mutationFn: async (caseIds: number[]) => {
      const results = await Promise.all(caseIds.map(getData))
      return results
    },
    onSuccess: (results) => {
      const allValid = results.every((data) => data.registros.length > 0)
      if (allValid) {
        onSuccess(casesNumbers.current)
      } else {
        onError(casesNumbers.current, 'Caso incompleto. Por favor, envíe el caso nuevamente.')
      }
    },
    onError: () => {
      onError(
        casesNumbers.current,
        'Hubo un problema al validar los casos. Por favor, inténtelo de nuevo.',
      )
    },
  })

  const getValidation = (values: { caseId: number; caseNumber: string }[]) => {
    casesNumbers.current = values.map((val) => val.caseNumber)
    mutation.mutate(values.map((val) => val.caseId))
  }

  return { getValidation, isLoading: mutation.isPending }
}
